import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../../staff/StaffSideMenu";
import API_URL from "../../../api/API";
import { useStaffAuthContext } from "../../staff/useStaffAuthContext";
import { Link, useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import {
  MdAdd,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
} from "react-icons/md";
import { FiEdit2 } from "react-icons/fi";
import { RiDeleteBin4Line } from "react-icons/ri";

export const AdminManageStrengthTrainingFocusTemplates = () => {
  const { staff } = useStaffAuthContext();
  const navigate = useNavigate();

  const [trainingFocuses, setTrainingFocuses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [training_focus, setTrainingFocus] = useState("");
  const [training_phase, setTrainingPhase] = useState("");

  const [deletePopup, setDeletePopup] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  const [expandedRowId, setExpandedRowId] = useState(null);

  useEffect(() => {
    const fetchTrainingFocuses = async () => {
      setIsLoading(true);
      try {
        const res = await fetch(
          API_URL.ADMIN_STRENGTH_TEMPLATE_TRAINING_FOCUS_MANAGE,
          {
            headers: { Authorization: `Bearer ${staff.token}` },
          },
        );
        const data = await res.json();
        setTrainingFocuses(data.data || []);
        setTotalPages(Math.ceil((data.data || []).length / itemsPerPage));
      } catch (err) {
        //setError("Failed to load training focus data.");
      } finally {
        setIsLoading(false);
      }
    };

    if (staff?.token) fetchTrainingFocuses();
  }, [staff.token]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredTrainingFocuses = trainingFocuses.filter((item) => {
    const focus = item.training_focus?.toLowerCase() || "";
    const phase = item.training_phase?.toLowerCase() || "";
    return focus.includes(searchQuery) || phase.includes(searchQuery);
  });

  const handleCreate = async () => {
    if (!training_focus || !training_phase) {
      setError("Both Training Focus and Phase are required.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await fetch(
        API_URL.ADMIN_POST_STRENGTH_TEMPLATE_CREATE_TRAINING_FOCUS,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
          body: JSON.stringify({ training_focus, training_phase }),
        },
      );

      const newData = await response.json();
      setTrainingFocuses((prev) => [...prev, newData.data]);
      setShowModal(false);
      setTrainingFocus("");
      setTrainingPhase("");

      if (newData?.data?._id) {
        navigate(
          `/administrator/template-strength/training-focus/edit/${newData.data._id}`,
        );
      }
    } catch (err) {
      setError("Failed to create training focus.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedTemplateId) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_DELETE_STRENGTH_TEMPLATE_TRAINING_FOCUS}${selectedTemplateId}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${staff.token}` },
        },
      );

      if (res.ok) {
        setTrainingFocuses((prev) =>
          prev.filter((item) => item._id !== selectedTemplateId),
        );
        setDeletePopup(false);
        setSelectedTemplateId(null);
      } else {
        alert("Failed to delete training focus.");
      }
    } catch (err) {
      alert("Error deleting training focus.");
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) setCurrentPage(newPage);
  };

  return (
    <div className="flex md:h-screen">
      <StaffSideMenu />
      <div className="max-md:w-full md:flex-1 bg-bgBase flex flex-col font-inter">
        {/* top part title inpit and btn */}
        <div className="bg-white space-y-6 pt-5 pb-3 md:py-6 px-5 md:px-10 xl:px-16">
          <h1 className="font-inter font-medium text-dark text-xl md:text-2xl !leading-none max-md:pl-12">
            Manage Strength Workouts
          </h1>
          <div className="flex flex-wrap md:justify-between md:items-center gap-3">
            <div className="relative w-full min-w-64 max-w-64">
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearch}
                placeholder="Search training focus..."
                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal leading-3 text-sm pl-10"
              />
              <span className="absolute top-1/2 -translate-y-1/2 left-3">
                <CiSearch color="#666666" size={20} />
              </span>
            </div>
            <button
              onClick={() => setShowModal(true)}
              className="px-6 py-3 flex items-center gap-2 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
            >
              <MdAdd color="#fff" size={18} /> Create Training Focus
            </button>
          </div>
        </div>

        <div className="py-10 px-5 md:px-8 xl:px-16">
          <div className="w-full max-w-[1336px]">
            {error && (
              <div className="bg-red-100 text-red-600 text-sm font-normal p-2 rounded mb-4">
                {error}
              </div>
            )}
            <div className="overflow-auto show-scrollbar max-h-[650px]">
              {isLoading ? (
                <div className="bg-white text-dark text-sm font-normal p-2 rounded mb-4">
                  Loading...
                </div>
              ) : (
                <div className="rounded-10 border border-tblBorder w-full">
                  <div className="bg-white rounded-10 shadow overflow-auto">
                    <div className="w-full">
                      {/* <thead className="bg-gray-200 sticky top-0">
                          <tr>
                            <th className="px-4 py-2 text-left">Training Focus</th>
                            <th className="px-4 py-2 text-left">Training Phase</th>
                            <th className="px-4 py-2 text-left">Actions</th>
                          </tr>
                        </thead> */}
                      <div className="overflow-auto">
                        {filteredTrainingFocuses
                          .slice(
                            (currentPage - 1) * itemsPerPage,
                            currentPage * itemsPerPage,
                          )
                          .map((item) => (
                            <>
                              <div
                                key={item._id}
                                className="bg-white border-b border-tblBorder last:border-transparent cursor-pointer w-full flex flex-nowrap justify-between items-center"
                              >
                                <div className="py-2 px-3 md:px-4 md:py-4 ">
                                  <p className="text-dark text-sm font-medium capitalize mb-1">
                                    {item.training_focus}
                                  </p>
                                  <p className="text-slate100 text-xs font-medium capitalize">
                                    {item.training_phase}
                                  </p>
                                </div>

                                <div className="px-4 py-2 space-x-2 flex-none">
                                  <div className="flex justify-end items-center gap-2">
                                    <Link
                                      to={`/administrator/template-strength/training-focus/edit/${item._id}`}
                                      className="p-1.5 rounded hover:bg-gray-200"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <FiEdit2 color="#666666" size={18} />
                                    </Link>
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedTemplateId(item._id);
                                        setDeletePopup(true);
                                      }}
                                      className="p-1.5 rounded hover:bg-gray-200"
                                    >
                                      <RiDeleteBin4Line
                                        color="#666666"
                                        size={20}
                                      />
                                    </button>
                                    <button
                                      onClick={() =>
                                        setExpandedRowId(
                                          expandedRowId === item._id
                                            ? null
                                            : item._id,
                                        )
                                      }
                                      className="p-2 rounded hover:bg-gray-200"
                                    >
                                      {expandedRowId === item._id ? (
                                        <>
                                          <MdKeyboardArrowUp
                                            color="#6A7282"
                                            size={20}
                                          />
                                        </>
                                      ) : (
                                        <>
                                          {" "}
                                          <MdKeyboardArrowDown
                                            color="#6A7282"
                                            size={20}
                                          />
                                        </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>

                              {expandedRowId === item._id && (
                                <>
                                  <div className="bg-bgBase w-full px-4 py-3">
                                    <div className="bg-white border border-10 rounded-10 divide-y divide-tblBorder">
                                      {item.items?.map((it, idx) => {
                                        if (it.type === "exercise") {
                                          return (
                                            <>
                                              <div key={idx} className="flex">
                                                <div className="py-3 px-4">
                                                  <p className="text-slate100 font-normal text-sm">
                                                    {idx + 1}
                                                  </p>
                                                </div>
                                                <div className="py-3 px-4">
                                                  <h4 className="text-slate100 font-normal text-sm">
                                                    Exercise
                                                  </h4>
                                                </div>
                                                <div className="py-3 px-4">
                                                  <p className="text-dark font-medium text-sm">
                                                    {it.exercise?.exercise_id
                                                      ?.title ||
                                                      "Untitled Exercise"}
                                                  </p>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        }

                                        if (it.type === "superset") {
                                          return (
                                            <div key={idx} className="mt-4">
                                              <h4 className="text-dark text-sm font-medium capitalize px-4 pt-3">
                                                Superset:{" "}
                                                {it.superset?.title ||
                                                  "Untitled Superset"}
                                              </h4>
                                              <div className="px-4 py-3">
                                                <div className="bg-white border border-10 rounded-10 divide-y divide-tblBorder">
                                                  <ul className="text-sm font-normal text-slate100 divide-y divide-tblBorder">
                                                    {it.superset?.exercises?.map(
                                                      (ex, i) => (
                                                        <li
                                                          key={i}
                                                          className="px-4 py-3"
                                                        >
                                                          {ex.exercise_id
                                                            ?.title ||
                                                            "Untitled Exercise"}
                                                        </li>
                                                      ),
                                                    )}
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }

                                        if (it.type === "circuit") {
                                          return (
                                            <div key={idx} className="mt-4">
                                              <h4 className="text-dark text-sm font-medium capitalize px-4 pt-3">
                                                Circuit:{" "}
                                                {it.circuit?.title ||
                                                  "Untitled Circuit"}
                                              </h4>
                                              <div className="px-4 py-3">
                                                <div className="bg-white border border-10 rounded-10 divide-y divide-tblBorder">
                                                  <ul className="text-sm font-normal text-slate100 divide-y divide-tblBorder">
                                                    {it.circuit?.exercises?.map(
                                                      (ex, i) => (
                                                        <li
                                                          key={i}
                                                          className="px-4 py-3"
                                                        >
                                                          {ex.exercise_id
                                                            ?.title ||
                                                            "Untitled Exercise"}
                                                        </li>
                                                      ),
                                                    )}
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }

                                        return null;
                                      })}
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-tblBorder px-5 md:px-8 xl:px-16 block md:mt-auto bg-white">
          <div className="w-full max-w-[1336px] flex justify-between items-center gap-5 p-4">
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
              className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                currentPage === 1 ? "cursor-not-allowed" : "text-black"
              }`}
            >
              <MdKeyboardArrowLeft size={20} /> Previous
            </button>
            <span className="text-dark font-inter font-normal text-sm">
              Page {currentPage} of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
              className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                currentPage === totalPages ? "cursor-not-allowed" : "text-black"
              }`}
            >
              Next <MdKeyboardArrowRight size={20} />
            </button>
          </div>
        </div>

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
              <div className="p-5">
                <h2 className="text-dark text-xl font-medium">
                  Create Training Focus
                </h2>
              </div>

              <div className="p-5 border-y border-tblBorder space-y-3">
                <input
                  type="text"
                  className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 outline-none font-medium"
                  value={training_focus}
                  onChange={(e) => setTrainingFocus(e.target.value)}
                  placeholder="Enter Training Focus (e.g. Strength)"
                />

                <input
                  type="text"
                  className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 outline-none font-medium"
                  value={training_phase}
                  onChange={(e) => setTrainingPhase(e.target.value)}
                  placeholder="Enter Training Phase (e.g. Base)"
                />
              </div>
              <div className="p-5">
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={() => {
                      setShowModal(false);
                      setTrainingFocus("");
                      setTrainingPhase("");
                      setError("");
                    }}
                    className="bg-transparent border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleCreate}
                    className="bg-dark border border-tblBorder rounded-10 py-2.5 px-5 text-white font-inter font-medium text-sm leading-tight capitalize hover:bg-black transition"
                  >
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {deletePopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
              <div className="p-5">
                <h2 className="text-dark text-xl font-medium">
                  Confirm Delete
                </h2>
              </div>
              <div className="p-5 border-y border-tblBorder space-y-3 text-sm font-normal">
                <p>Are you sure you want to delete this training focus?</p>
              </div>
              <div className="p-5">
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={() => setDeletePopup(false)}
                    className="bg-transparent border border-tblBorder rounded-10 py-2.5 px-5
 text-dark font-inter font-medium text-sm leading-tight capitalize
 hover:bg-dark hover:text-white transition"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="bg-dark border border-tblBorder rounded-10 py-2.5 px-5 text-white
 font-inter font-medium text-sm leading-tight capitalize hover:bg-black transition"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
